import { getFirstCategoryUrlFormat } from '../../../components/App/utils';
import { LOGGER_TYPES } from '../../loggerTypes';
import {
  wixDocsShareableLinkClick,
  wixDocsSendRequestClient,
  wixDocsGiveFeedbackClick,
} from '.';
import {
  fromRelativeUrlToAbsoluteUrl,
  removeRouterBasename,
  removeStartingSlash,
} from '../../../../utils/locationUtils';

const fromUrlToMember = (url) => url.replace(/\//g, '.');

export const getArticleNameFromHashPrefix = (hashPrefix, categoryName) => {
  return fromUrlToMember(hashPrefix.replace(`${categoryName}/`, ''));
};

export const getArticleNameFromPathname = (pathname, store) => {
  const path = removeStartingSlash(
    removeRouterBasename(pathname, store.storePath),
  );
  const articlePath = path.split('/').splice(1);
  if (!articlePath.length) {
    return undefined;
  }
  return articlePath.join('/');
};

export const getCategoryNameFromPathname = (pathname, store) =>
  removeStartingSlash(removeRouterBasename(pathname, store.storePath)).split(
    '/',
  )[0];

export const getCategoryName = (pathname, store) => {
  if (pathname === store.storePath || pathname === `${store.storePath}/`) {
    return getFirstCategoryUrlFormat(store);
  }
  return getCategoryNameFromPathname(pathname, store);
};

export const sendShareableLinkClickEventLog = (
  logger,
  store,
  location,
  hashPrefix,
) => {
  const categoryName = getCategoryName(location.pathname, store);
  logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsShareableLinkClick, {
    category_name: categoryName,
    article_name: getArticleNameFromHashPrefix(hashPrefix, categoryName),
    article_url: fromRelativeUrlToAbsoluteUrl(
      `/${hashPrefix}`,
      window.location.origin,
      store,
    ),
  });
};

export const sendSendRequestClientEventLog = (
  logger,
  store,
  location,
  hashPrefix,
  body,
  method,
  url,
  isTestTokenUsed,
) => {
  const categoryName = getCategoryName(location.pathname, store);
  const bodyBase64 = btoa(escape(JSON.stringify(body)));
  logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsSendRequestClient, {
    article_name: getArticleNameFromHashPrefix(hashPrefix, categoryName),
    article_url: fromRelativeUrlToAbsoluteUrl(
      `/${hashPrefix}`,
      window.location.origin,
      store,
    ),
    body: bodyBase64,
    category_name: categoryName,
    http_method: method,
    invoked_url: url,
    is_test_token_used: isTestTokenUsed,
  });
};

export const sendGiveFeedbackClickEvent = (
  logger,
  articleName,
  articleUrl,
  positiveFeedback,
) => {
  logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsGiveFeedbackClick, {
    article_name: articleName,
    article_url: articleUrl,
    positive_feedback: positiveFeedback,
  });
};
